/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Applicationpreference } from '../../models/applicationpreference';

export interface AppPreferencesGetPreferences$Params {
}

export function appPreferencesGetPreferences(http: HttpClient, rootUrl: string, params?: AppPreferencesGetPreferences$Params, context?: HttpContext): Observable<StrictHttpResponse<Applicationpreference>> {
  const rb = new RequestBuilder(rootUrl, appPreferencesGetPreferences.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Applicationpreference>;
    })
  );
}

appPreferencesGetPreferences.PATH = '/api/AppPreferences';
